import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import IllegalConstructionSidebar from "../IllegalConstructionSidebar/IllegalConstructionSidebar";
import { ZoneNameCommanDDL } from "../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { HeaderIllegal } from "../HeaderIllegal";
import { WardNameCommanDDL } from "../../../../../../Components/IllegalDDL/WardNameCommanDDL";
import ServeNoticePopup from "./Modal/ServeNoticePopup";
import UploadComplaintDetailsPopup from "./Modal/UploadComplaintDetailsPopup";
import SiteVisitDetailsPopup from "./Modal/SiteVisitDetailsPopup";
import SiteVerificationDetailsPopup from "./Modal/SiteVerificationDetailsPopup";
import BoundariesPopup from "./Modal/BoundariesPopup";

export const ClosedComplaintIllegalGrid = () => {

    const { t } = useTranslation()
    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };


    const [DashType, setDashType] = useState(localStorage.getItem('DashType') ? localStorage.getItem('DashType') : 1)

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const DataObj = ({
        isCountLoading: '',
        Language: Language.Label
    })


    const [UploadComplaintDetails, setUploadComplaintDetails] = useState(false)
    const [SiteVisitDetails, setSiteVisitDetails] = useState(false)
    const [SiteVerificationDetails, setSiteVerificationDetails] = useState(false)
    const [BoundariesPopUpShow, setBoundariesPopUpShow] = useState(false)
    const [ServeNotice, setServeNotice] = useState(false)

    const handleUploadComplaintDetails = () => {
        setUploadComplaintDetails(!UploadComplaintDetails)
    }

    const handleSiteVisitDetails = () => {
        setSiteVisitDetails(!SiteVisitDetails)
    }

    const handleSiteVerificationDetails = () => {
        setSiteVerificationDetails(!SiteVerificationDetails)
    }
    const handleBoundaries = () => {
        setBoundariesPopUpShow(!BoundariesPopUpShow)
    }

    const handleServeNotice = () => {
        setServeNotice(!ServeNotice)
    }


    return (
        <>
            <HeaderIllegal />
            <div className="wrapper bg-change">

                <IllegalConstructionSidebar />

                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">

                            {/* Closed Complaint/ */}
                            <h5 className="text-dark fw-bold ps-3 pt-3 all_heading_fontsize">
                                {t('EncroachmentDashboard.ClosedComplaint')}

                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 eic_table_styles py-2" >

                        <div class="col-12 col-lg-2 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                        </div>

                        <div class="col-12 col-lg-2 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                        </div>


                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                            />
                        </div>

                        <div class="col-12 col-lg-2 pt-2">
                            <WardNameCommanDDL />
                        </div>

                        <div className="col-12 col-lg-3 col-md-4 mt-3">

                            <button type="button" className="btn btn-success mx-3 mt-4">Search</button>
                            <button type="button" className="btn btn-danger mt-4">Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintCloseDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Ward')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.AreaName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.UploadComplaintDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.SiteVisitDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.SiteVerificationDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ConstructionBoundariesDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.CompletedPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ShowNotice')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ServeNotice')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintTrack')}</th>
                                                {/* <th className="text-center">{t('EncroachmentDashboard.Remark')}</th> */}

                                            </tr>

                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td className="py-1" align="center">1</td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>

                                                <td className="text-center"
                                                    onClick={() => handleUploadComplaintDetails()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                <td className="text-center"
                                                    onClick={() => handleSiteVisitDetails()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                <td className="text-center"
                                                    onClick={() => handleSiteVerificationDetails()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                <td className="text-center"
                                                    onClick={() => handleBoundaries()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                <td className="text-center">
                                                    <button className="view_button">
                                                        {/* {t('EncroachmentDashboard.View')} */}
                                                        <i class="fa-solid fa-image"></i>
                                                    </button>
                                                </td>

                                                <td className="text-center"
                                                // onClick={() => handleUploadComplaintDetails()}
                                                >
                                                    <span className="cursor-pointer">
                                                        {/* {t('EncroachmentDashboard.View')} */}
                                                        <i class="fa-solid fa-file text-danger"></i>
                                                    </span>
                                                </td>


                                                <td className="text-center"
                                                    onClick={() => handleServeNotice()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>
                                                <td className="text-center">
                                                    <button className="Track_button">
                                                        {t('EncroachmentDashboard.Track')}
                                                    </button>
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>


                        </div>

                    </div>


                </div>
            </div>


            {
                UploadComplaintDetails ?
                    <UploadComplaintDetailsPopup
                        handleUploadComplaintDetails={handleUploadComplaintDetails}
                        heading={t('EncroachmentDashboard.UploadComplaintDetails')}
                    /> : <></>
            }

            {
                SiteVisitDetails ?
                    <SiteVisitDetailsPopup
                        handleSiteVisitDetails={handleSiteVisitDetails}
                        heading={t('EncroachmentDashboard.SiteVisitDetails')}
                    /> : <></>
            }

            {
                SiteVerificationDetails ?
                    <SiteVerificationDetailsPopup
                        handleSiteVerificationDetails={handleSiteVerificationDetails}
                        heading={t('EncroachmentDashboard.SiteVerificationDetails')}
                    /> : <></>
            }

            {
                BoundariesPopUpShow ?
                    <BoundariesPopup
                        message="Construction Boundaries"
                        handleBoundaries={handleBoundaries}
                    /> : <></>
            }

            {
                ServeNotice ?
                    <ServeNoticePopup
                        handleServeNotice={handleServeNotice}
                        heading={t('EncroachmentDashboard.ServeNotice')}
                    /> : <></>
            }



        </>
    )
}

